module.exports = __webpack_public_path__ + "media/theme/border-11-57857267.png";